import { Component, type ErrorInfo, type ReactNode } from 'react';

import { ErrorCallout } from '../../shared';

type SDKUsageErrorBoundaryState = {
  hasError: boolean;
};

type SDKUsageErrorBoundaryProps = {
  children: ReactNode;
};

export class SDKUsageErrorBoundary extends Component<SDKUsageErrorBoundaryProps, SDKUsageErrorBoundaryState> {
  state: SDKUsageErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): SDKUsageErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('SDK Usage Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorCallout>
          <strong>Failed to load SDK connections</strong>
          <p>SDK connection data could not be loaded. Refresh the page and try again.</p>
        </ErrorCallout>
      );
    }

    return this.props.children;
  }
}
